import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { fetchWebsiteSettings } from '../../../redux/slices/settings/statisticsSlice';
import CountUp from 'react-countup'; // Import react-countup
import Statisticsbg from './../../../assets/images/bgsection/Statisticsbg.png';
import { BsFillPatchCheckFill } from "react-icons/bs";
import { FaMagic } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { RiApps2Fill } from "react-icons/ri";
import SectionTitle from '../../SectionTitle/SectionTitle';
import { useInView } from 'react-intersection-observer';
import Loading from '../../UI/Loading/Loading';
const StatisticsSection = ({ t, language }) => {
    const iconMap = {
        1: <RiApps2Fill />, // Icon for Services
        2: <FaUserGroup />, // Icon for Beneficiaries
        3: <BsFillPatchCheckFill />, // Icon for Requests
        4: <FaMagic />, // Icon for Repairs
    };
    const [startCount, setStartCount] = useState(false);
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.5,
    });
    React.useEffect(() => {
        if (inView) {
            setStartCount(true);
        }
    }, [inView]);
    const dispatch = useDispatch();
    const { settings, loading, error } = useSelector((state) => state.statistics);



    useEffect(() => {
        dispatch(fetchWebsiteSettings());
    }, [dispatch]);

    useEffect(() => {
        if (inView) {
            setStartCount(true);
        }
    }, [inView]);

    if (loading) return <Loading/>;
    // if (error) return <Typography>Error: {error}</Typography>;

    return (
        <Box
            ref={ref} // Attach the intersection observer to the Box component
            sx={{
                background: `url(${Statisticsbg}) 50% 10% / cover fixed no-repeat, #000000`,
                color: '#fff',
                textAlign: 'center',
                py: 8,
                px: 2,
                mt: "40px"
            }}
        >
            {/* Header Section */}
            <Box mb={6} data-aos="fade-down">
                <SectionTitle
                    title={t.statisticTitle}
                    fontSize="32px"
                    color="#fff"
                    fontWeight={700}
                    lineHeight="39.08px"
                    mb={2}
                    dataAos="fade-down"
                />
                <Typography sx={{ color: '#ccc', fontSize: "18px" }}>
                    {t.statisticDescription}                </Typography>
            </Box>

            {/* Counter Blocks */}
            <Grid sx={{
                display: 'flex',
                flexWrap: 'wrap', // Ensure items wrap on smaller screens
                justifyContent: 'center',
                gap: 4 // Space between items
            }} data-aos="fade-in">
                {settings.slice(0, 4).map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} lg={2.5} xl={2} key={item.Id}>
                        <Box
                            key={item.Id}
                            sx={{
                                flex: '1 1 calc(25% - 32px)', // Adjust width for responsive design
                                maxWidth: 'calc(25% - 32px)', // Ensures items don't exceed this width
                                minWidth: '200px', // Minimum width for cards
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                borderRadius: '5px',
                                padding: "30px 10px 10px 10px",
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                                backdropFilter: 'blur(2px)',
                                transition: 'transform 0.3s',
                                '&:hover': { transform: 'translateY(-10px)' },
                                position: "relative",
                                border: "1px solid rgba(255,255,255,.2)",
                                mt: 2
                            }}
                        >
                            {/* Icon */}
                            <Box
                                sx={{
                                    backgroundColor: '#fff',
                                    color: 'var(--primary-color)',
                                    borderRadius: '50%',
                                    width: '70px',
                                    height: '70px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '30px',
                                    mb: 2,
                                    top: "-30px",
                                    position: "absolute"
                                }}
                            >
                                {iconMap[index + 1]}
                            </Box>

                            {/* Title */}
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 3, mt: 3 }}>
                                {language === 'Arabic' ? item?.ValueAr : item?.Value}
                            </Typography>

                            {/* Counter Value */}
                            <Typography variant="h4" fontWeight="bold" mb={3}>
                                {startCount && (
                                    <CountUp
                                        start={0}         // Start counting from 0
                                        end={item.ValueNumeric}
                                        duration={2.5}    // Duration in seconds
                                        separator=","     // Add comma as a separator
                                    />
                                )}
                                +
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default StatisticsSection;
